import React, { useState, useEffect, useCallback } from 'react';
import NotificationVerticalTabs from './NotificationTabs';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from "react-helmet";
import { notificationApiV2 } from 'redux/actions/notification';
import { useHistory } from 'react-router-dom';
import Breadcrumb from 'web/components/Breadcrumb';
import Button from "web/components/Button";

import Layout from 'web/components/Layout';
import AlertModal from 'web/components/AlertModal';
import { Container } from './NotificationStyled'
import { fetchLanguageContentNew } from 'redux/actions/language';

const Notification = (props) => {
  const token = localStorage.getItem('token');
  let history = useHistory();
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [notificationResponse, setNotificationResponse] = useState([]);
  const [notificationPageData, setNoficationPageData] = useState([]);
  const [notificationPageDataInfo, setNoficationPageDataInfo] = useState('');

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (languageContentNew?.Notifications_Page) setPageLanguageContents(languageContentNew.Notifications_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    fetchMyAPI()
  }, []);

  const fetchMyAPI = async (actionType, pageNo) => {
    let actionTypeTemp = actionType || "ALL"
    if (actionType == 'BID' || actionType == 'ALT_BID') actionTypeTemp = 'LOAD'
    if (actionType == 'OFFER' || actionType == 'ALT_OFFER' || actionType == 'BUY_NOW_DEL' || actionType == 'BUY_NOW_PICKUP') actionTypeTemp = 'INVENTORY'
    let data = {
      size: 10,
      number: pageNo ? pageNo - 1 : 0,
      actionType: [actionTypeTemp]
    }
    let response = await dispatch(notificationApiV2(token, data));
    if (response.success) {
      if (pageNo === 1) setNoficationPageDataInfo('pageResetToOne')
      else setNoficationPageDataInfo('')
      if (response.data) {
        setNotificationResponse(response.data)
        if (actionType === 'ALL' || actionTypeTemp === 'ALL') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.allNotifications])
          else setNoficationPageData(response.data?.allNotifications)
        } else if (actionType === 'ORDER') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.orderNotifications])
          else setNoficationPageData(response.data?.orderNotifications)
        } else if (actionType === 'NETWORK') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.myCommunityNotifications])
          else setNoficationPageData(response.data?.myCommunityNotifications)
        } else if (actionType === 'CLAIM_RESOLUTION') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.resolutionCenterNotifications])
          else setNoficationPageData(response.data?.resolutionCenterNotifications)
        } else if (actionType === 'PICKUP') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.pickupNotifications])
          else setNoficationPageData(response.data?.pickupNotifications)
        } else if (actionType === 'LOAD') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postNeedNotifications?.needNotifications])
          else setNoficationPageData(response.data?.postNeedNotifications?.needNotifications)
        } else if (actionType === 'BID') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postNeedNotifications?.needBidNotifications])
          else setNoficationPageData(response.data?.postNeedNotifications?.needBidNotifications)
        } else if (actionType === 'ALT_BID') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postNeedNotifications?.needAltBidNotifications])
          else setNoficationPageData(response.data?.postNeedNotifications?.needAltBidNotifications)
        } else if (actionType === 'INVENTORY') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postInventoryNotifications?.invNotifications])
          else setNoficationPageData(response.data?.postInventoryNotifications?.invNotifications)
        } else if (actionType === 'OFFER') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postInventoryNotifications?.invOfferNotifications])
          else setNoficationPageData(response.data?.postInventoryNotifications?.invOfferNotifications)
        } else if (actionType === 'ALT_OFFER') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postInventoryNotifications?.invAltOfferNotifications])
          else setNoficationPageData(response.data?.postInventoryNotifications?.invAltOfferNotifications)
        } else if (actionType === 'BUY_NOW_DEL') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postInventoryNotifications?.invBuyNowNotifications])
          else setNoficationPageData(response.data?.postInventoryNotifications?.invBuyNowNotifications)
        } else if (actionType === 'BUY_NOW_PICKUP') {
          if (pageNo > 1) setNoficationPageData(prevData => [...prevData, ...response.data?.postInventoryNotifications?.invBuyNowPickupNotifications])
          else setNoficationPageData(response.data?.postInventoryNotifications?.invBuyNowPickupNotifications)
        }
      }
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else if (response?.data?.error?.message === 'No results.') {
        if (pageNo === 1) setNoficationPageData([])
        setNoficationPageDataInfo('endOfResults')
      }
    }
  }

  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: '/dashboard',
      eventType: 'Link'
    },
  ]

  return (
    <>
      <Helmet title="Notifications: Stay Informed with Marketplace Updates | PalletTrader" >
        <meta name="description"
          content="Receive important updates and notifications about your marketplace activity. Stay informed about pallet bids, offers, orders, and other relevant information." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/notification" />
      </Helmet>
      <Layout transparentHeader={false} topBarViewMobile={"hide"}>
        <Container>
          <Breadcrumb breadcrumbArr={breadcrumbMapArr} selected={pageLanguageContents?.Breadcrumb[1]?.Notification} title="" />
          <NotificationVerticalTabs
            notificationResponse={notificationResponse}
            notificationPageData={notificationPageData}
            notificationPageDataInfo={notificationPageDataInfo}
            fetchSelectedPageData={(actionType, pageNo) => fetchMyAPI(actionType, pageNo)}
          />
        </Container>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content={modalContent}
          link={modalLink}
        />
      </Layout>
    </>
  )
};
export default Notification;
